import DeviceManager from '../utils/device-manager';

class KeyFiguresSlider {
    constructor($el) {
        this.$el = $el;

        this.options = {
            autoPlay: true,
            pageDots: false,
            wrapAround: false,
            prevNextButtons: false,
            cellSelector: '.key_figures-slider__figure-block'
        };
        this.slider = null;

        if(this.$el.length) {
            this._onBreakpointChange();
            this.isInitialized = true;

            this._bindEvents();
        }
    }

    _bindEvents() {
        this._onBreakpointChangeFn = this._onBreakpointChange.bind(this);

        DeviceManager.on('device-manager:breakpointChange', this._onBreakpointChangeFn);
    }

    _destroy() {
        if(this.slider) {
            this.$el.flickity('destroy');
            this.slider = null;
        }
    }

    _onBreakpointChange() {
        if(DeviceManager.currentBreakpoint === 'mobile') {
            this._destroy();
            this.slider = this.$el.flickity(this.options);
        }
        else if(DeviceManager.currentBreakpoint !== 'mobile' && DeviceManager.previousBreakpoint === 'mobile') {
            this._destroy();
        }
    }
}

export default KeyFiguresSlider;
